type SnackBarErrorsProps = {
  text: string;
  errors: string[];
};

export const SnackBarErrors: React.FC<SnackBarErrorsProps> = ({
  text,
  errors,
}: SnackBarErrorsProps) => {
  return (
    <div className="snackbar">
      <div className="snackbar-label">{text}</div>

      <ol>
        {errors.map((error, index) => (
          <p key={index} className="snackbar-error">
            {index + 1} {error}
          </p>
        ))}
      </ol>
    </div>
  );
};
